export enum EquationPartTypes {
  operator = 'operator',
  factor = 'factor',
  number = 'number',
  parenthesise = 'parenthesise'
}
